import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'

import { graphql, useStaticQuery } from 'gatsby'
import Image from 'gatsby-image'

const LlamadoAccion = ({ id }) => {

    const getImagenes = graphql`
	{
		cesione:file(relativePath: {eq: "icono-cesione.png"}) {
			childImageSharp {
				fluid{
					...GatsbyImageSharpFluid
				}
			}
		}

	}`
    const data = useStaticQuery(getImagenes);
    const { cesione } = data;



    return (
        <section id={id} className="page-section bg-azul" style={{ marginTop: '7rem' }}>
            <Container>
                <Row className="justify-content-center">

                    <Col md={6} className="text-right texto-cesione">
                        <div className="img-cesione-sm">
                            <Image fluid={cesione.childImageSharp.fluid} />
                        </div>
                        <h2 className="text-white mt-0">¿Solo necesitas una plataforma para ceder y re-ceder tus documentos?</h2>
                        <br />
                        <a className="btn btn-outline-light" href="https://www.cesione.cl/" target="_blank" rel="noreferrer" style={{ fontSize: '1.1rem' }}>
                            ¡Conoce cesione!
                        </a>

                    </Col>
                    <Col lg={3} md={4} className="px-5 mt-3 img-cesione-md">
                        <Image fluid={cesione.childImageSharp.fluid} />
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default LlamadoAccion
